import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      settings: 'person/settings',
      person: 'person/person'
    })
  },
  methods: {
    assertSetting (key, value) {
      return this.settings[key] === String(value)
    }
  }
}
